var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCuba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8125e-05 3.47827H0V36.5217H7.8125e-05V20.0001V3.47827Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 39.9999C31.0456 39.9999 39.9998 31.0456 39.9998 20C39.9998 8.95433 31.0456 6.10352e-05 19.9999 6.10352e-05C8.95427 6.10352e-05 0 8.95433 0 20C0 31.0456 8.95427 39.9999 19.9999 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.00012207C13.4569 0.00012207 7.64797 3.14254 3.99915 8.00012H36.0008C32.352 3.14247 26.5431 0.00012207 20 0.00012207V0.00012207Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C26.5431 39.9999 32.352 36.8575 36.0009 31.9999H3.99915C7.6479 36.8576 13.4569 39.9999 20 39.9999Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0001C0 21.37 0.138125 22.7076 0.400547 24.0001H39.5995C39.862 22.7076 40 21.37 40 20.0001C40 18.6301 39.8619 17.2925 39.5995 16.0001H0.400547C0.138125 17.2925 0 18.6301 0 20.0001V20.0001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85779 5.85797C-1.9526 13.6684 -1.9526 26.3317 5.85779 34.1423C9.08537 30.9147 12.1894 27.8106 19.9999 20.0002L5.85779 5.85797Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09462 14.7827L9.38947 18.7683H13.5806L10.1902 21.2317L11.485 25.2173L8.09462 22.754L4.70408 25.2173L5.99923 21.2317L2.60876 18.7683H6.79955L8.09462 14.7827Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuba);
export default __webpack_public_path__ + "static/media/cuba.5f88571e479448ab0134f79704ba1f8c.svg";
export { ForwardRef as ReactComponent };